import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/modules';

import { NavigationComponent } from './navigation.component';

@NgModule({
  imports: [SharedModule, RouterModule],
  exports: [NavigationComponent],
  declarations: [NavigationComponent],
})
export class NavigationModule {}
